// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"74d5c23b","340":"b43869b7","392":"0b280c06","453":"6d886622","560":"3b079c3d","668":"f72a1f5d","673":"fe6b6aa2"}[chunkId] + ".chunk.js";
};